<template>
    <div class="test">
        <headers :title='title'></headers>
        <template>
            <div class="topicSwitch"
                 v-if="list.length">
                <topicSwitch @child="switch_topic"
                             v-if="tarType==0"></topicSwitch>
                <h3 class="sum"
                    v-if="(tarType==1||tarType==4)&&askLength">共{{askLength}}题</h3>
            </div>
            <div class="content"
                 v-if="list.length">
                <div class="topic"
                     v-if='loading'
                     v-for="(topic,tindex) in list">
                    <!-- 一题多问的大题干 -->
                    <div class="title"
                         v-if="topic.asks.length">
                        <p v-html="topic.article_title"
                           v-if="topic.article_title"></p>
                        <p :class="{'topic-con':topic.article_title}"
                           v-if="topic.article_text"
                           v-html="topic.article_text"></p>
                        <p :class="{'topic-con':topic.article_title}"
                           v-html="topic.content"
                           v-if="topic.content"></p>
                    </div>
                    <!-- 一题多问的大题题干图片 -->
                    <template v-if="topic.asks.length&&topic.image">
                        <div class="cont_img"
                             v-for=" (img) in topic.image ">
                            <img :src="img"
                                 alt="" />
                        </div>
                    </template>
                    <div :class="{'ask':topic.asks.length&&askInd}"
                         v-for="(ask,askInd) in topic.asks">
                        <!-- 选择题 -->
                        <div v-if="ask.type===1||ask.type===3||ask.type===7||ask.type===8">
                            <choose-component :ask="ask"
                                              :type="ask.type"></choose-component>
                        </div>
                        <!-- 填空题 -->
                        <div v-if="ask.type === 2">
                            <fill-component :ask="ask"></fill-component>
                        </div>
                        <!-- 连线题 -->
                        <div v-if="ask.type === 4">
                            <line-component :ask="ask"
                                            :onlyshow="true"
                                            :sheet="ask.right_answer"></line-component>
                        </div>
                        <!-- 断句 -->
                        <div v-if="ask.type===6">
                            <sentence-component :ask="ask"></sentence-component>
                        </div>
                        <!-- 连词成句 -->
                        <div v-if="ask.type===5">
                            <make-component :ask="ask"
                                            :is_answer="true"
                                            :type="ask.type"></make-component>
                        </div>
                    </div>
                    <i class="is_issue"
                       v-if="topic.published_status && tarType!=4"></i>
                    <div class="bottom">
                        <span v-if="tarType==4">错题率：{{wrong_list[tindex]}}%</span>
                        <span v-else>使用次数：{{topic.published_count}}次</span>
                        <a href="javascript:;"
                           :class="{'remove':topic.active}"
                           @click="addOrRemove(topic)">{{addOrRemoveText[topic.active]}}</a>
                    </div>
                </div>
                <div class="issue">
                    <div class="num">
                        <i></i>
                        已选（{{activeLength}}题）
                    </div>
                    <div :class="[activeLength?'toIssue bule':'toIssue']"
                         @click="toIssue"
                         v-if="activeList.length ">去发布</div>
                    <div class="toIssue"
                         v-else>去发布</div>

                </div>
            </div>
            <template v-else-if="!list.length&&loading">
                <noResouse></noResouse>
            </template>
        </template>
        <template v-if='!loading'>
            <loadingS></loadingS>
        </template>
        <moreLoading v-show='ismoreLoading'></moreLoading>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
import moreLoading from 'COMPONENTS/moreLoading.vue';
import chooseComponent from 'VIEWS/chinese/module/result_choose.vue';   //选择题
import fillComponent from 'VIEWS/chinese/module/result_fill.vue';   //填空题
import lineComponent from 'VIEWS/chinese/module/result_line.vue';   //连线题
import makeComponent from 'VIEWS/chinese/module/result_make.vue';   //连词成句、连句成段题
import sentenceComponent from 'VIEWS/chinese/module/result_sentence.vue';   //断句题
import topicSwitch from 'VIEWS/chinese/module/topic_switch.vue';  //题型范围

export default {
    data () {
        return {
            sid: this.$route.params.sid,
            type: this.$route.params.type,
            tarType: Number(this.$route.query.tarType),
            paper_id: localStorage.getItem('paperIds'),
            wrong_list: localStorage.getItem('wrong_list'),//高频错题
            title: '',
            loading: false,
            list: [],
            askLength: 0,//list中的小题题量
            activeList: [],
            activeLength: 0,//选中题的小题题量
            addOrRemoveText: ['加入', '移除'],
            activeType: { question_type: 0, send_type: 0 },
            page: 1,
            loadOver: false,
            ismoreLoading: false
        }
    },
    components: {
        headers, loadingS, noResouse, chooseComponent, fillComponent, lineComponent, makeComponent, sentenceComponent, topicSwitch, moreLoading
    },
    methods: {
        toIssue () {
            // if (this.activeLength > 30) {
            //     layer.tips('已超出30道题，无法发布');
            if (this.activeLength > 100) {
                layer.tips('已经超出100道题，无法发布');
                return
            } else {
                let obj = {
                    qid: this.activeList,
                    paper_id: this.paper_id
                };
                this.$store.commit('setreleaseid', obj);
                if (this.type == 1) {
                    this.type = 3;
                } else if (this.type == 0) {
                    this.type = 2;
                }
                this.$router.push('/chinese/release/51/' + this.type);
            }
        },
        switch_topic (data) {
            this.loading = false;
            // layer.open({type: 2, shadeClose: false});
            this.activeType.question_type = data.tixing;
            this.activeType.send_type = data.fanwei;
            this.page = 1;
            this.loadOver = false
            this.getList();
        },
        addOrRemove (topic) {
            // if (topic.active || this.activeLength < 30) {
            if (topic.active || this.activeLength < 100) {
                topic.active ? topic.active = 0 : topic.active = 1;
                this.list.splice(0, 1, this.list[0]);
                if (!topic.active) {
                    this.activeList.forEach((v, index) => {
                        if (v === topic.id) {
                            this.activeList.splice(index, 1);
                            this.activeLength -= topic.asks.length;
                        }
                    })
                } else {
                    this.activeList.push(topic.id);
                    this.activeLength += topic.asks.length;
                }
            } else {
                layer.tips('已经超出100道题，不能再添加试题了')
            }
        },
        loadMore () {
            let that = this;
            this.loadMoreTimer && clearTimeout(this.loadMoreTimer);
            this.loadMoreTimer = setTimeout(function () {
                let docHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
                let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                let winHeight = window.screen.availHeight;
                if (winHeight + scrollTop >= docHeight - 20) {
                    if (!that.loadOver) {
                        if (!that.tarType) {
                            that.ismoreLoading = true;
                        }
                        that.getList();
                    }
                }
            }, 500)
        },
        getList () {
            if (this.tarType == 0) {
                //自选题进来的
                let obj = {
                    ch_id: this.paper_id,
                    task_type: Number(this.type),
                    question_type: this.activeType.question_type,
                    send_type: this.activeType.send_type,
                    p: this.page
                };
                this.$http.post(API_URL_TASK_API + '/chinese/make/self_practice', obj).then(res => {
                    res = res.data;
                    if (res.response === 'ok') {
                        if (res.data.length) {
                            if (this.page > 1) {
                                this.list = this.list.concat(res.data);
                            } else {
                                window.scrollTo(0, 0);
                                this.list = res.data;
                            }
                            this.list.forEach(v => {
                                v.active = 0;
                                this.activeList.forEach(a => {
                                    if (v.id === a) {
                                        v.active = 1;
                                    }
                                });
                            });
                            this.page++;
                            layer.closeAll();
                        } else {
                            if (this.page > 1) {
                                this.loadOver = true;
                                layer.tips('已加载全部内容');
                            } else {
                                this.list = [];
                                layer.closeAll();
                            }
                        }
                        this.loading = true;
                        this.ismoreLoading = false;
                    }
                })
            } else if (this.page === 1) {
                if (this.tarType == 4) {
                    //高频错题进来的
                    // //console.log(this.wrong_list)
                    this.wrong_list = this.wrong_list.split(',');
                    this.$http.post(API_URL_TASK_API + '/chinese/make/paper/data', {
                        qid: this.paper_id
                    }).then(res => {
                        res = res.data;
                        if (res.response === 'ok') {
                            this.list = res.data;
                            this.list.forEach(v => {
                                v.active = 1;
                                this.askLength += v.asks.length;
                                this.activeList.push(v.id);
                                this.activeLength += v.asks.length;
                            });
                            this.page++;
                            this.loading = true;
                        }
                    })
                } else {
                    //同步习题、单元复习选择自选卷进来的
                    this.$http.post(API_URL_TASK_API + '/chinese/make/exercises_question', {
                        paper_id: this.paper_id
                    }).then(res => {
                        res = res.data;
                        if (res.response === 'ok') {
                            this.list = res.data;
                            this.list.forEach(v => {
                                this.askLength += v.asks.length;
                                if(!v.published_status){
                                    v.active = 1;
                                    this.activeList.push(v.id);
                                    this.activeLength += v.asks.length;
                                }else{
                                    v.active = 0;
                                }
                            });
                            this.page++;
                            this.loading = true;
                        }
                    })
                }
            }
        }
    },
    destroyed () {
        clearInterval(this.loadMoreTimer);
        window.removeEventListener('scroll', this.loadMore, true)
    },
    created () {
        //console.log(this.paper_id)
        let chinese_send_ok = localStorage.getItem('chinese_send_ok');
        if (chinese_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        this.title = (this.tarType == 1 || this.tarType == 4) ? '习题预览' : '自己选题';
        this.getList();
        window.addEventListener('scroll', this.loadMore, true)
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.ask {
    border-top: 1px / $ppr solid #e8e8e8;
}

.test {
    min-height: 100vh;
    padding-bottom: 96px / $ppr;
    box-sizing: border-box;
    &.pad {
        padding-bottom: 96px / $ppr;
    }
    .header-wrap {
        .header {
            background: #5e89ef;
        }
        .left {
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/white_back.png") no-repeat;
            background-size: 100% 100%;
        }
    }
    .sum {
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 30px / $ppr;
        font-weight: bold;
        color: #333;
        background: #fff;
    }
    .topicSwitch {
        position: fixed;
        top: 96px / $ppr;
        left: 0;
        width: 100vw;
        z-index: 8;
    }
    .content {
        padding-top: 96px / $ppr;
        margin-bottom: 24px / $ppr;
        font-size: 30px / $ppr;
        color: #333;
        .topic {
            position: relative;
            margin-top: 24px / $ppr;
            background: #fff;
            .title {
                p {
                    padding: 34px / $ppr 24px / $ppr;
                    &.topic-con {
                        border-top: 1px / $ppr solid #e8e8e8;
                    }
                }
            }
            .bottom {
                position: relative;
                padding: 0 24px / $ppr;
                height: 96px / $ppr;
                line-height: 96px / $ppr;
                font-size: 24px / $ppr;
                color: #999;
                border-top: 1px / $ppr solid #e8e8e8;
                a {
                    position: absolute;
                    right: 24px / $ppr;
                    top: 50%;
                    margin-top: -24px / $ppr;
                    display: block;
                    width: 122px / $ppr;
                    height: 48px / $ppr;
                    line-height: 48px / $ppr;
                    font-size: 24px / $ppr;
                    text-align: center;
                    border: 1px / $ppr solid #5e89ef;
                    color: #5e89ef;
                    border-radius: 48px / $ppr;
                    box-sizing: border-box;
                    &.remove {
                        border: 1px / $ppr solid #ff6600;
                        color: #ff6600;
                    }
                }
            }
            .is_issue {
                position: absolute;
                top: 24px / $ppr;
                right: 0;
                display: block;
                width: 100px / $ppr;
                height: 56px / $ppr;
                background: url("./img/icon_issue.png") no-repeat;
                background-size: 100% 100%;
            }
        }
        .issue {
            position: fixed;
            bottom: -1px / $ppr;
            left: 0;
            width: 100vw;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            z-index: 7;
            div {
                float: left;
                text-align: center;
                font-size: 30px / $ppr;
                color: #333;
                &.num {
                    width: 70%;
                    background: #f0f0f0;
                    i {
                        display: inline-block;
                        margin-right: 24px / $ppr;
                        width: 50px / $ppr;
                        height: 42px / $ppr;
                        background: url("./img/icon1.png") no-repeat;
                        background-size: 100% 100%;
                        vertical-align: middle;
                    }
                }
                &.toIssue {
                    width: 30%;
                    color: #fff;
                    background: #ccc;
                }
                &.bule {
                    background: #5e89ef;
                }
            }
        }
    }
}
.topic /deep/ .ask {
    border-top: 0 !important;
}
</style>
